import React, { Component } from "react";
import queryString from "query-string";
import { Card, CardBody, Col, Row } from "reactstrap";

// datatable related plugins
import "react-bootstrap-table2-filter/dist/react-bootstrap-table2-filter.min.css";

import PropTypes from "prop-types";
import styled from "styled-components";

import ReactTableForm from "../../../components/Common/ReactTableForm";
import DynamicFormFilters from '../../../components/forms/DynamicFormFilters';

const UsersRecUAH = (props) => {
  const defaultStyle = {
    textAlign: "center",
    width: "auto",
    verticalAlign: "middle",
  }

  const recTypes = {
    debit: "DEBIT",
    credit: "CREDIT",
    balance: "BALANCE",
  }

  const columns = [
    {
      Header: "#",
      isSorted: true,
      accessor: (row, rowIndex) => <>{rowIndex}</>,
      style: {
        ...defaultStyle,
        maxWidth: 10,
      },
    },
    {
      Header: "Contractor",
      isSorted: true,
      accessor: row => {
        if (row.type == recTypes.balance) {
          return (
            <NameLink onClick={e => onClickRow(e, row, "edit")}>
              {row.label}
            </NameLink>
          );
        } else {
          return (
            <NameLink onClick={e => onClickRow(e, row, "edit")}>
              {row.contractor}
            </NameLink>
          );
        }
      },
      style: {
        ...defaultStyle,
        maxWidth: 50,
        minWidth: 20,
      },
    },
    {
      Header: "Operation",
      //        accessor: "type",
      isSorted: true,
      accessor: row => {
        let t = {
          'CREDIT': 'Invoice',
          'DEBIT': 'Payment'
        }
        if (t[row.type]) {
          return (
            <NameLink onClick={e => onClickRow(e, row, "edit")}>
              {`${t[row.type]}`}
            </NameLink>
          );
        }
        if (row.type !== recTypes.balance) {
          let date = new Date(row?.date).toJSON().split("T");
          return (
            <NameLink onClick={e => onClickRow(e, row, "edit")}>
              Payment: {`${date[0]} (${date[1].replace(/\..*/, "")})`}
            </NameLink>
          );
        }
      },
      style: {
        ...defaultStyle,
        maxWidth: 20,
        minWidth: 20,
      },
    },
    {
      Header: "Date",
      //        accessor: "type",
      isSorted: true,
      accessor: row => {
        if (row.type !== recTypes.balance) {
          let date = new Date(row?.date).toJSON().split("T");
          return (
            <NameLink onClick={e => onClickRow(e, row, "edit")}>
              {`${row?.date}`}
            </NameLink>
          );
        }
      },
      style: {
        ...defaultStyle,
        maxWidth: 50,
      },
    },
    {
      Header: "Debit",
      //        accessor: "type",
      isSorted: true,
      style: {
        ...defaultStyle,
        width: "250px",
      },
      accessor: row => {
        if (row?.type == recTypes.debit) {
          return (
            <NameLink onClick={e => onClickRow(e, row, "edit")}>
              {row?.amount || 0}
            </NameLink>
          );
        } else {
          return (
            <NameLink onClick={e => onClickRow(e, row, "edit")}>
              {row?.start_balance}
            </NameLink>
          );
        }
      },
    },
    {
      Header: "Credit",
      //        accessor: "type",
      isSorted: true,
      style: {
        ...defaultStyle,
        width: "250px",
      },
      show: false,
      accessor: row => {
        if (row?.type == recTypes.credit) {
          return (
            <NameLink onClick={e => onClickRow(e, row, "edit")}>
              {row?.amount || 0}
            </NameLink>
          );
        } else {
          return (
            <NameLink onClick={e => onClickRow(e, row, "edit")}></NameLink>
          );
        }
      },
    },
    {
      Header: "Beneficiary company",
      accessor: "beneficiary_company",
      isSorted: true,
      style: {
        ...defaultStyle,
        width: 300,
      },
      show: false,
    },
  ];

  const cellProps = (info, test) => {
    if (info.row.original?.is_sum) {
      return {
        style: {
          ...defaultStyle,
          fontWeight: "600",
          backgroundColor: "#91ebd2",
        },
      };
    } else if (info.row.original?.type == "BALANCE") {
      return {
        colSpan: 3,
        style: {
          ...defaultStyle,
        },
      };
    } else {
      return {
        style: {
          ...defaultStyle,
        },
      };
    }
  };

  const onClickRow = (e, row) => {
  };

  const handleChangeFilters = (filters, type, status) => {
    props.onFiltersChange(filters, type, status)
  }

  return (
    <MainStyle>
      <Row>
        <Col className="col-12">
          <Card>
            <CardBody>

              <DynamicFormFilters
                cardcolor="#fff"
                filterDelay={10}
                FilterContainerClass="rec-user--filters"
                onFiltersChange={handleChangeFilters}
                onDateRangeChange={props.handleDateRangeChange}
                // isLoadingSelect={props.topReportsFiltersLoading}
                disableFilterBy
                filtered_params={queryString.parse(
                  props.history.location.search
                )}
                filtersFields={[
                  {
                    filterData: props.contractors?.results
                      ? props.contractors?.results.map(i => {
                        return {
                          id: i.id,
                          name: i.counterparty_name,
                        };
                      })
                      : [],
                    title: "Contractor",
                    plug: "Contractor...",
                    filterType: "contractor",
                    style: {
                      marginLeft: "auto",
                    },
                    // customWidth: "230px",
                  },
                  {
                    filterData: props.contractors?.results
                      ? props.legalEntity?.results.map(i => {
                        return {
                          id: i.id,
                          name: i.counterparty_name,
                        };
                      })
                      : [],
                    title: "Beneficiary company",
                    plug: "Beneficiary company...",
                    filterType: "beneficiary_company",
                  },
                ]}
                filtered_by={["contractor", "beneficiary_company"]}
                // filtered_params={"all"}
                selectedDate={[]}
                dateFilters={[
                  {
                    // customWidth: "230px",
                    plug: "Date",
                    key: "date",
                    filterType: ["start_date", "end_date"],
                    value: props.defDate,
                    clearDate: false,
                    pickerName: "reconciliation",
                    dateRange: true,
                    customWidth: `200px`,
                  },
                ]}
              />

              <ScrollTable>
                {!props.loader_reconciliation ? (
                  <ReactTableForm
                    className="rec--table"
                    loading={props.loader_reconciliation}
                    columns={columns}
                    data={{
                      results: props.reconciliations?.transactions || [],
                    }}
                    onTableChange={() => console.log("")}
                    getCellProps={(cellInfo, key) =>
                      cellProps(cellInfo, key)
                    }
                    isStriped={false}
                    overflow={false}
                    firstCellIsMultiple
                  />
                ) : (
                  <div
                    className="loader-for-react-table justify-content-center"
                    style={{ display: "flex", padding: "45px 0" }}
                  >
                    <div
                      className="spinner-border text-primary m-1"
                      role="status"
                    >
                      <span className="sr-only">Loading...</span>
                    </div>
                  </div>
                )}
              </ScrollTable>
              {props.reconciliations?.transactions?.length > 0 ? (
                <StyleFooter>
                  <div>
                    Total for the period:{" "}
                    <span>
                      {props.reconciliations?.balance_by_period || 0}
                    </span>
                  </div>
                  <div>
                    Balance as of {props.reconciliations?.end_date}:{" "}
                    <span>
                      {props.reconciliations?.balance || 0}
                    </span>
                  </div>
                </StyleFooter>
              ) : (
                ""
              )}
            </CardBody>
          </Card>
        </Col>
      </Row>
    </MainStyle>
  );
}

const MainStyle = styled.div`
  .rec--filters {
  }
`;

const ScrollTable = styled.div`
  overflow-x: auto;

  .rec--table {
    min-width: 1200px;
  }
`;

const StyleFooter = styled.div`
  font-size: 14px;

  div {
    span {
      font-weight: 600;
    }
  }
`;
const NameLink = styled.div`
  transition-duration: 0.1s;

  &:hover {
    /* color: rgb(85, 110, 230); */
    transition-duration: 0.1s;
  }
`;

UsersRecUAH.propTypes = {
  history: PropTypes.object.isRequired,
  permissions: PropTypes.object.isRequired,
  reconciliations: PropTypes.object.isRequired,
  loader_reconciliation: PropTypes.bool,
  defDate: PropTypes.object.isRequired,
  onFiltersChange: PropTypes.func.isRequired,
  handleDateRangeChange: PropTypes.func.isRequired,
  contractors: PropTypes.object,
  legalEntity: PropTypes.object,
};

export default UsersRecUAH;
